import * as yup from "yup";

const DEFAULT_MSG = "Este campo es requerido."

const adCampaignSchema = yup.object().shape({
    code: yup.string().required(DEFAULT_MSG),
});

export {
    adCampaignSchema
}